import { URLS } from 'Douleutaras/constants/urls';
import { ResponseV2 } from 'Douleutaras/redux/data/auth/types';
import { parseV3ErrorsInline } from 'Douleutaras/utilities/normalizers/api-errror-normalizer';

export const redirectToLogin = () => window.location.href = URLS.AUTHENTICATION.LOGIN;

export const responseStatus = (response): number => response.status || response.payload.response.status;

export const normalizeResponseV2 = <T>(response): ResponseV2<T> => {
  const status = responseStatus(response);

  return {
    result: status === 200 || status === 201
      ? 'success'
      : 'error',
    data: status === 200 || status === 201
      ? response.data
      : parseV3ErrorsInline(
        status === 500
          ? { server: 'Please contact us' }
          : response.payload.response.data
      )
  };
};
